import { render, staticRenderFns } from "./MindOnline.vue?vue&type=template&id=2b06d7d3"
import script from "./MindOnline.vue?vue&type=script&lang=js"
export * from "./MindOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports